import React from 'react';
import MetricCard from './MetricCard';
import { Card, CardContent, Divider, Grid, Box, Typography } from '@mui/material';
import CustomSkeleton from '../Skeleton/CustomSkeleton';

function KpiGrid({
  title,
  metricsData,
  width = '100%',
  selectedPage,
  isKPICardLoading,
  timeFrame = '',
  activeCycleId = null,
  cyclesData = []
}) {
  return isKPICardLoading ? (
    <Box
      data-testid="kpi-grid-skeleton"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        padding: '16px 24px',
        borderRadius: '8px',
        border: '1px solid #DBEAFE',
        backgroundColor: '#F8FAFC',
        width: '100%',
        height: '200px'
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh'
        }}
      >
        <CustomSkeleton />
      </Box>
    </Box>
  ) : (
    <Card
      data-testid="kpi-grid-container"
      sx={{ backgroundColor: '#fbfcfe', borderRadius: '8px', width: width }}
    >
      <CardContent>
        <Grid container justifyContent="space-evenly" alignItems="center">
          {metricsData && metricsData?.length > 0 ? (
            metricsData?.map((metric, index) => (
              <React.Fragment key={metric.title}>
                <Grid item alignItems={'center'}>
                  <MetricCard
                    {...metric}
                    selectedPage={selectedPage}
                    isKPICardLoading={isKPICardLoading}
                    timeFrame={timeFrame}
                    cyclesData={cyclesData}
                    activeCycleId={activeCycleId}
                  />
                </Grid>
                {index < metricsData.length - 1 && (
                  <Grid item>
                    <Divider
                      orientation="vertical"
                      flexItem
                      sx={{ height: '100px', borderColor: '#b2caea' }}
                    />
                  </Grid>
                )}
              </React.Fragment>
            ))
          ) : (
            <Grid item xs={12}>
              <Typography data-testid="no-data" variant="body1" sx={{ textAlign: 'center' }}>
                No Data!
              </Typography>
            </Grid>
          )}
        </Grid>
      </CardContent>
    </Card>
  );
}

export default KpiGrid;
